var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,172) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672 1563 c-62 -30 -77 -65 -80 -187 l-4 -109 -54 54 -54 53 -35 -34 -35 -34 112 -113 113 -113 112 112 113 113 -35 35 -35 34 -50 -49 -50 -49 0 90 c0 57 4 94 12 102 8 8 45 12 100 12 l88 0 0 50 0 50 -92 0 c-65 0 -103 -5 -126 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 1335 l0 -245 45 0 c34 0 45 4 45 15 0 13 6 11 29 -6 60 -44 146 0 170 88 26 91 -3 202 -59 231 -33 17 -87 8 -116 -19 l-24 -22 0 101 0 102 -45 0 -45 0 0 -245z m184 -1 c50 -50 21 -174 -40 -174 -34 0 -54 36 -54 97 0 40 5 58 20 73 24 24 53 26 74 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 932 l-47 -48 0 -305 0 -305 48 -47 48 -47 355 0 355 0 47 48 47 48 0 303 0 304 -47 48 -47 49 -356 0 -356 0 -47 -48z m753 -352 l0 -300 -350 0 -350 0 0 300 0 300 350 0 350 0 0 -300z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 765 c-103 -37 -155 -173 -106 -280 10 -22 27 -48 37 -57 50 -44 145 -60 213 -37 29 10 31 14 31 56 0 39 -2 44 -17 38 -10 -4 -37 -10 -60 -12 -37 -5 -46 -2 -73 25 -25 26 -30 38 -30 81 0 70 31 105 91 106 24 0 54 -4 67 -8 21 -8 22 -6 22 38 0 40 -3 47 -26 55 -36 14 -102 12 -149 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.57aceba737f31060dc7b172b1560f7d9.svg";
export { ForwardRef as ReactComponent };